<template>
    <div class="pl-field" :class="{ 'pl-field--error': error }" :data-field="field">
        <label :for="inputId">{{ label }}</label>
        <div class="pl-multiselect" :class="{ 'pl-control--error': error }">
            <div class="pl-multiselect-control">
                <span v-for="item in modelValue" :key="item.value" class="pl-chip">
                    <span>{{ item.label }}</span>
                    <button type="button" class="pl-chip-remove" :aria-label="'Rimuovi ' + item.label" @click="remove(item.value)">×</button>
                </span>
                <div class="pl-search">
                    <svg class="pl-search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                        <circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" />
                    </svg>
                    <input
                        :id="inputId"
                        v-model="needle"
                        :aria-label="'Cerca ' + label"
                        placeholder="Cerca…"
                        autocomplete="off"
                        @focus="open = true"
                        @blur="onBlur"
                    >
                </div>
            </div>
            <div v-if="open" class="pl-results">
                <div v-if="loading" class="pl-results-message">Ricerca…</div>
                <button
                    v-for="(result, index) in available"
                    :key="result.id"
                    type="button"
                    class="pl-result-row"
                    :class="{ 'pl-result-row--highlighted': index === 0 }"
                    @mousedown.prevent
                    @click="pick(result)"
                >{{ result.text }}</button>
                <div v-if="!loading && !available.length" class="pl-results-message">Nessun risultato</div>
            </div>
        </div>
        <p v-if="error" class="pl-field-error">{{ error }}</p>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'RemoteMultiSelect',
    props: {
        field: { type: String, required: true },
        label: { type: String, required: true },
        modelValue: { type: Array, default: () => [] },
        route: { type: String, default: '' },
        error: { type: String, default: '' },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            needle: '',
            results: [],
            open: false,
            loading: false,
            timer: null,
        };
    },
    computed: {
        inputId() {
            return `pl-${this.field}`;
        },
        available() {
            const taken = new Set(this.modelValue.map((item) => String(item.value)));

            return this.results.filter((result) => !taken.has(String(result.id)));
        },
    },
    watch: {
        needle() {
            this.scheduleSearch();
        },
        open(value) {
            if (value) {
                this.scheduleSearch();
            }
        },
    },
    beforeUnmount() {
        window.clearTimeout(this.timer);
    },
    methods: {
        scheduleSearch() {
            if (!this.open || !this.route) {
                return;
            }
            window.clearTimeout(this.timer);
            this.loading = true;
            this.timer = window.setTimeout(() => this.search(), 180);
        },
        async search() {
            try {
                const { data } = await axios.get(this.route, {
                    params: { needle: this.needle },
                    headers: { Accept: 'application/json' },
                });
                const rows = Array.isArray(data) ? data : [];
                this.results = rows.map((row) => ({
                    id: String(row.id ?? row.value ?? ''),
                    text: String(row.text ?? row.label ?? row.id ?? ''),
                })).filter((row) => row.id !== '');
            } catch (error) {
                this.results = [];
            } finally {
                this.loading = false;
            }
        },
        pick(result) {
            this.$emit('update:modelValue', [...this.modelValue, { value: result.id, label: result.text }]);
            this.needle = '';
            this.open = false;
        },
        remove(value) {
            this.$emit('update:modelValue', this.modelValue.filter((item) => item.value !== value));
        },
        onBlur() {
            window.setTimeout(() => {
                this.open = false;
            }, 160);
        },
    },
};
</script>
